import { NgClass } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ChangeLangService } from '../services/mainServices/change-lang-service';
import { StateService } from '../services/mainServices/state';
import { SwitchThemeService } from '../services/mainServices/switch-theme-service';
import { FirebaseService } from '../services/firebase/firebase';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogModule, NgClass, ToastModule, ButtonModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected readonly title = signal('aynWebApp');

  themeService = inject(SwitchThemeService);
  primeng = inject(PrimeNG);
  stateService = inject(StateService);
  cls = inject(ChangeLangService);
  firebaseService = inject(FirebaseService);

  private readonly router = inject(Router);

  ngOnInit(): void {
    document.documentElement.style.fontSize = `${'14'}px`;
    this.primeng.ripple.set(true);
    this.primeng.inputStyle.set('filled');
    this.setLang();
    this.setTheme();
    this.firebaseService.requestPermission();

    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }
  setTheme() {
    this.themeService.switchTheme(
      localStorage.getItem('theme') ? localStorage.getItem('theme')! : 'light',
    );
  }
  setLang(): void {
    this.cls.changeLang(
      localStorage.getItem('langCode') ? localStorage.getItem('langCode')! : 'en',
    );
  }
}
